export interface NounPluralFormatterOptions {
  count: number;
  suffix?: string;
  overrideNoun?: string;
  addCountWhenSingular?: boolean;
}

export function nounPluralFormatter(noun: string, options: NounPluralFormatterOptions): string {
  if (options.overrideNoun) {
    return options.count === 1 ? noun : options.overrideNoun;
  }

  if (options.suffix) {
    return addSuffixWhenNounPlural(
      noun,
      options.count,
      options.addCountWhenSingular,
      options.suffix
    );
  }

  return addSuffixWhenNounPlural(noun, options.count, options.addCountWhenSingular);
}

export function addSuffixWhenNounPlural(
  noun: string,
  numberToCheck: number,
  addCountWhenSingular = false,
  suffix = 's'
): string {
  if (addCountWhenSingular && numberToCheck === 1) {
    return `1 ${noun}`;
  }

  return numberToCheck === 1 ? noun : `${numberToCheck} ${noun}${suffix}`;
}

export function capitalise(word: string | undefined): string {
  if (!word) {
    return '';
  }

  return word.charAt(0).toUpperCase() + word.slice(1);
}

export function kebabToCamel(str: string | undefined) {
  if (!str) {
    return '';
  }

  return str.replace(/-([a-zA-Z0-9])/g, function replacer(_, p1) {
    return p1.toUpperCase();
  });
}

export function kebabUnderscoreToDisplayString(str: string | undefined) {
  if (!str) {
    return '';
  }

  return str
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase());
}

export function kebabToPascal(str: string | undefined): string {
  if (!str) {
    return '';
  }

  return str
    .replace(/-([a-zA-Z0-9])/g, function replacer(_, p1) {
      return p1.toUpperCase();
    })
    .replace(/(^|-)([a-zA-Z0-9])/g, function replacer(_, __, p2) {
      return p2.toUpperCase();
    });
}

export function addDelimiter(delimiter: string, ...words: string[]) {
  return words.filter(word => word.trim()).join(delimiter);
}

export function getUnreadDisplayCount(count: number): string | number {
  return count >= 100 ? '99+' : count;
}

export const getMaskedString = (text: string, replaceWith = '\u2022') =>
  text.replace(/\*/g, replaceWith);
